import { Row, Col } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { useWindowsSize } from "../../libs";
import CardService from "../Card/CardService";
import CardTool from "../Card/CardTools";
import Loading from "../Main/Loading";

function Homepage({ props }) {
  const {
    menu,
    parameter,
    handleMenu,
    handleParameter,
    loading,
    loadPage,
    layanan,
    satuan,
    media,
    handlePagination,
    onModal,
    isMore,
    onFilter,
    filter,
    covidRef,
    scrollCovid,
  } = props;

  const size = useWindowsSize();

  // const layanan = [];
  // const media = [];

  return (
    <div className="homep">
      <div className="container mx-auto py-10 lg:py-20">
        {/* Card Header Section */}
        <Row>
          <Col lg={14} md={14} sm={24} xs={24} className="lg:pr-20">
            <div className="home-card w-full relative p-6">
              <p className="header-title colors-blue m-0 font-semibold text-base lg:text-3xl ">
                Solusi,{" "}
                <span className="font-bold header-title-bold">
                  Kesehatan Anda
                </span>
              </p>
              <div className="w-3/4 lg:w-3/5 mt-3">
                <p className="header-content colors-gray text-xs lg:text-base">
                  Update informasi seputar kesehatan atau BBLK semua bisa
                  disini!
                </p>
              </div>

              <Link to="/account/register">
                <button className="btn-blue w-2/4 p-2 mt-3 lg:w-1/4  lg:p-3 focus:outline-none text-white">
                  <p className="header-content m-0 text-xs lg:text-sm tracking-wider">
                    Daftar
                  </p>
                </button>
              </Link>
              <img
                className="absolute h-4/5 w-auto -top-8 right-0 lg:h-auto lg:-top-14"
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_calender.svg"
                }
                alt="icon-calender"
              />
            </div>
          </Col>
          <Col lg={10} md={10} sm={24} xs={24}>
            <div className="home-card-second w-full relative py-6 px-6 mt-10 md:mt-0 lg:mt-0 lg:py-5">
              <p className="header-title colors-blue text-base font-bold lg:font-semibold lg:text-2xl m-0">
                Layanan Khusus
              </p>
              <div className="w-3/4 lg:w-3/6 my-3 lg:my-5">
                <p className="header-content colors-gray  text-xs lg:text-base">
                  Test Covid 19, Cegah Corona Sedini Mungkin{" "}
                </p>
              </div>
              <div
                onClick={scrollCovid}
                className="flex items-center mb-3 cursor-pointer"
              >
                <p className="header-title colors-blue m-0 font-semibold">
                  Daftar Tes
                </p>
                <img
                  className="ml-3"
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/icon/ic_arrow_homepage.svg"
                  }
                  alt="icon-arrow"
                />
              </div>
              <img
                className="absolute h-2/3 w-auto lg:h-auto -top-6 lg:-top-14 right-4"
                src={
                  process.env.REACT_APP_BASE_URL + "/assets/icon/ic_vaccine.svg"
                }
                alt="icon-vaccine"
              />
            </div>
          </Col>
        </Row>

        {/* Card Tracking */}
        <div
          name="card-tracking"
          className="home-tracking mt-10 lg:mt-14 p-6 w-full flex justify-between items-center"
          onClick={() => size.width <= 640 && onModal()}
        >
          <div className="flex items-center">
            <div className="h-4/56 w-auto lg:h-auto lh:w-auto">
              <img
                className="lg:-mt-12"
                src={
                  process.env.REACT_APP_BASE_URL + "/assets/icon/ic_track.svg"
                }
                alt="icon-calender"
              />
            </div>
            <div className="ml-4">
              <p className="header-title colors-blue m-0 mb-2 text-base lg:text-2xl font-semibold">
                Track Pemeriksaan
              </p>
              <p className="header-content colors-gray m-0 text-xs lg:text-base">
                Kamu dapat mengecek progress pemeriksaanmu disini
              </p>
            </div>
          </div>
          <div
            onClick={() => size.width > 640 && onModal()}
            className="flex items-center cursor-pointer"
          >
            {size.width > 640 && (
              <p className="header-title colors-blue m-0 font-semibold lg">
                Track
              </p>
            )}

            {size.width > 640 && (
              <img
                className="lg:ml-3"
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_arrow_homepage.svg"
                }
                alt="icon-arrow"
              />
            )}
          </div>
        </div>

        {/* Filter Section */}
        <div ref={covidRef} className="mt-10 lg:mt-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 lg:gap-10 ">
            <div
              className={`flex ${
                size.width <= 640
                  ? "home-disable-scroll overflow-x-scroll -ml-4 px-4"
                  : ""
              } pb-8 lg:pb-2 `}
            >
              <div
                onClick={() => (loading ? null : handleMenu(1))}
                className={`cursor-pointer ${
                  menu === 1 ? "home-filter-card-active" : "home-filter-card"
                } w-full mr-4 lg:w-full py-3 lg:py-2 px-8 lg:px-5`}
              >
                <p
                  className={`m-0 font-semibold text-center ${
                    menu === 1 ? "text-white" : "colors-blue"
                  } text-xs w-20 lg:w-auto lg:text-base`}
                >
                  All Product
                </p>
              </div>
              <div
                onClick={() => (loading ? null : handleMenu(2))}
                className={`cursor-pointer ${
                  menu === 2 ? "home-filter-card-active" : "home-filter-card"
                } w-full mr-4 lg:w-full py-3 lg:py-2 px-6 lg:px-5 `}
              >
                <p
                  className={`m-0 font-semibold text-center ${
                    menu === 2 ? "text-white" : "colors-blue"
                  } text-xs w-32 lg:w-auto lg:text-base`}
                >
                  Layanan Kesehatan
                </p>
              </div>
              <div
                onClick={() => (loading ? null : handleMenu(3))}
                className={`cursor-pointer ${
                  menu === 3 ? "home-filter-card-active" : "home-filter-card"
                } w-full mr-4 lg:w-full py-3 lg:py-2 px-6 lg:px-5 `}
              >
                <p
                  className={`m-0 font-semibold text-center  ${
                    menu === 3 ? "text-white" : "colors-blue"
                  } text-xs w-32 lg:w-auto lg:text-base`}
                >
                  Media Reagensia
                </p>
              </div>
            </div>

            {/* Right */}
            <div className="flex items-center lg:justify-end -mt-4 lg:mt-0 ">
              {menu !== 1 && (
                <div className="home-filter mr-2 p-3 ">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_filter.svg"
                    }
                    alt="icon-filter"
                  />
                </div>
              )}
              {menu !== 1 && (
                <div className="login-input-wrapper w-full lg:w-96">
                  <input
                    value={filter}
                    onChange={(e) => onFilter(e)}
                    onKeyPress={(e) => onFilter(e)}
                    className="home-form-input outline-none p-2 w-full"
                    placeholder="Search"
                    type="search"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Service Section */}
        <div className={`${menu === 1 ? "mt-3 " : "mt-8 "} lg:mt-10`}>
          {layanan.length > 0 && menu !== 3 && (
            <div>
              <p className="header-title colors-blue text-xl lg:text-3xl font-semibold">
                Pilih {parameter === 2 ? "Layanan" : "Paket"} Kesehatan Anda
              </p>
              {layanan.length > 0 && menu === 2 && (
                <div className="mt-5">
                  <div className="home-switch w-40 px-1 py-2 flex justify-around items-center">
                    <div
                      onClick={() => (loading ? null : handleParameter(1))}
                      className={`${
                        parameter === 1
                          ? "home-switch-active py-1 px-2 font-semibold "
                          : ""
                      } cursor-pointer colors-blue header-title `}
                    >
                      Paket
                    </div>
                    <div
                      onClick={() => (loading ? null : handleParameter(2))}
                      className={`${
                        parameter === 2
                          ? "home-switch-active py-1 px-2 font-semibold"
                          : ""
                      }  cursor-pointer colors-blue header-title `}
                    >
                      Layanan
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {loading ? (
            <Loading />
          ) : layanan.length > 0 ? (
            (menu === 1 || menu === 2) && (
              <div className="mt-5 lg:mt-8">
                <div className="grid grid-cols-2 grid-rows-1 gap-2 lg:gap-10 ">
                  {layanan.map((it, index) => (
                    <Link
                      key={index}
                      to={
                        parameter === 1
                          ? `/product/paket/${it.id}`
                          : `/product/satuan/${it.id}`
                      }
                    >
                      <CardService props={{ layanan: it }} />
                    </Link>
                  ))}
                </div>
              </div>
            )
          ) : (
            menu === 2 && (
              <div className="w-full mt-20 flex flex-row content-center justify-center">
                <div className="lg:w-1/3">
                  <div className="w-full flex justify-center">
                    <img
                      className="mb-8 w-4/5"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_empty_box.svg"
                      }
                      alt="icon-empty-cart"
                    />
                  </div>
                  <div className="w-full">
                    <p className="header-content text-center colors-blue text-xl font-semibold mb-4">
                      Layanan Kesehatan Sedang Kosong
                    </p>
                    <p className="header-content text-center colors-gray text-base mb-8">
                      Produk di layanan kesehatan sedang kosong, silahkan untuk
                      melihat tipe produk yang lain
                    </p>
                  </div>
                </div>
              </div>
            )
          )}
          {!loading &&
            menu === 1 &&
            layanan.length === 0 &&
            satuan.length === 0 &&
            media.length === 0 && (
              <div className="w-full mt-20 flex flex-row content-center justify-center">
                <div className="lg:w-1/3">
                  <div className="w-full flex justify-center">
                    <img
                      className="mb-8 w-4/5"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_empty_box.svg"
                      }
                      alt="icon-empty-cart"
                    />
                  </div>
                  <div className="w-full">
                    <p className="header-content text-center colors-blue text-xl font-semibold mb-4">
                      Semua Produk Sedang Kosong
                    </p>
                    <p className="header-content text-center colors-gray text-base mb-8">
                      Produk di layanan kesehatan sedang kosong, silahkan untuk
                      melihat tipe produk yang lain
                    </p>
                  </div>
                </div>
              </div>
            )}
        </div>

        {/* Satuan Section */}
        {satuan.length > 0 && menu === 1 && (
          <div className="mt-10 lg:mt-12">
            <p className="header-title colors-blue text-xl lg:text-3xl font-semibold mb-5">
              Pilih Layanan Kesehatan Anda
            </p>

            <div className="grid grid-cols-2 grid-rows-1 gap-2 lg:gap-10 ">
              {satuan.map((it, index) => (
                <Link key={index} to={`/product/satuan/${it.id}`}>
                  <CardService props={{ layanan: it }} />
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Tools Section */}
        {!loading && (menu === 1 || menu === 3) && media.length > 0 ? (
          <div className="mt-10 lg:mt-12">
            <p className="header-title colors-blue text-xl lg:text-3xl font-semibold mb-5">
              Pilih Media Reagensia
            </p>
            <div className="grid grid-cols-2 grid-rows-1 lg:grid-cols-5 gap-2 lg:gap-10 ">
              {media.map((it, idx) => (
                <Link key={idx} to={`/media/${it.id}`}>
                  <CardTool props={{ media: it }} />
                </Link>
              ))}
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {!loading && menu === 3 && Number(media.length) === 0 && (
          <div className="w-full mt-20 flex flex-row content-center justify-center">
            <div className="lg:w-1/3">
              <div className="w-full flex justify-center">
                <img
                  className="mb-8 w-4/5"
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/icon/ic_empty_box.svg"
                  }
                  alt="icon-empty-cart"
                />
              </div>
              <div className="w-full">
                <p className="header-content text-center colors-blue text-xl font-semibold mb-4">
                  Media Reagensia Sedang Kosong
                </p>
                <p className="header-content text-center colors-gray text-base mb-8">
                  Produk di media reagensia sedang kosong, silahkan untuk
                  melihat tipe produk yang lain
                </p>
              </div>
            </div>
          </div>
        )}

        {loading ||
          (menu !== 1 && isMore && (
            <div className="mt-10 w-full flex justify-center">
              <div className="lg:w-1/5 home-btn-more ">
                <button
                  disabled={loadPage}
                  className="colors-blue p-3 w-full focus:outline-none"
                  onClick={() => handlePagination()}
                >
                  <p className="m-0 text-white font-semibold">
                    {loadPage ? "Loading" : "Lihat Selengkapnya"}
                  </p>
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Homepage;
